import _ from "lodash";

import { useToggles } from "@/hooks/useToggles";
import { http } from "@/utils/http";
const createSyncTag = function (fn) {
  let syncTag = "";
  return function (form, callback) {
    syncTag = Math.random().toString(36);
    fn(
      form,
      (tag => {
        return tag === syncTag ? callback : function () {};
      })(syncTag)
    );
  };
};

const getResultByJobId = async (asyncJobId, form) => {
  const Y_TRAVELPORT_MESSAGE_DEBUGGING = useToggles(
    "Y_TRAVELPORT_MESSAGE_DEBUGGING"
  );

  if (Y_TRAVELPORT_MESSAGE_DEBUGGING.value) {
    if (!form._biz) {
      form._biz = {};
    }
    form._biz.tpMessageRequired = true;
  }
  const res = await http.post(
    `booking/hotel/search?mode=async&asyncJobId=${asyncJobId}`,
    { ...form }
  );
  if (
    res &&
    res._biz &&
    res._biz.tpMessage &&
    Y_TRAVELPORT_MESSAGE_DEBUGGING.value
  ) {
    console.log("booking/hotel/search>>>>tpMessage", res._biz.tpMessage);
  }
  return res;
};

export const getHotels = async form => {
  const Y_TRAVELPORT_MESSAGE_DEBUGGING = useToggles(
    "Y_TRAVELPORT_MESSAGE_DEBUGGING"
  );

  if (Y_TRAVELPORT_MESSAGE_DEBUGGING.value) {
    if (!form._biz) {
      form._biz = {};
    }
    form._biz.tpMessageRequired = true;
  }
  const res = await http
    .post("booking/hotel/search", { data: form })
    .catch(() => null);
  if (
    res &&
    res._biz &&
    res._biz.tpMessage &&
    Y_TRAVELPORT_MESSAGE_DEBUGGING.value
  ) {
    console.log("booking/hotel/search>>>>tpMessage", res._biz.tpMessage);
  }
  return res;
};

export const getHotelsAsync = async (form, callback, onError) => {
  const Y_TRAVELPORT_MESSAGE_DEBUGGING = useToggles(
    "Y_TRAVELPORT_MESSAGE_DEBUGGING"
  );

  if (Y_TRAVELPORT_MESSAGE_DEBUGGING.value) {
    if (!form._biz) {
      form._biz = {};
    }
    form._biz.tpMessageRequired = true;
  }
  let hotelRes = await http
    .post("booking/hotel/search?mode=async", { data: form })
    .catch(() => {
      onError && onError();
    });
  if (!hotelRes || hotelRes.err) {
    hotelRes = { hotels: [], paging: { count: 0 } };
    onError && onError();
  }

  if (hotelRes.asyncJobId) {
    hotelRes.hotels.forEach(item => {
      item.asyncJobId = hotelRes.asyncJobId;
    });
    getResultByJobId(hotelRes.asyncJobId, { data: form })
      .then(jobRes => {
        hotelRes = jobRes;
        hotelRes && callback(hotelRes);
      })
      .catch(() => {
        onError && onError();
      });
  }
  if (
    hotelRes &&
    hotelRes._biz &&
    hotelRes._biz.tpMessage &&
    Y_TRAVELPORT_MESSAGE_DEBUGGING.value
  ) {
    console.log("booking/hotel/search>>>>tpMessage", hotelRes._biz.tpMessage);
  }
  callback(hotelRes);
};

const getHotelRates = async (data, asyncJobId) => {
  const Y_TRAVELPORT_MESSAGE_DEBUGGING = useToggles(
    "Y_TRAVELPORT_MESSAGE_DEBUGGING"
  );

  if (Y_TRAVELPORT_MESSAGE_DEBUGGING.value) {
    if (!data._biz) {
      data._biz = {};
    }
    data._biz.tpMessageRequired = true;
  }
  let url = "booking/hotel/rates?mode=asyncPagingMerged";
  if (asyncJobId) {
    url = `${url}&asyncJobId=${asyncJobId}`;
  }
  const res = await http.post(url, { data });
  if (
    res &&
    res._biz &&
    res._biz.tpMessage &&
    Y_TRAVELPORT_MESSAGE_DEBUGGING.value
  ) {
    console.log("booking/hotel/rates>>>>tpMessage", res._biz.tpMessage);
  }
  return res;
};

const getJobResult = async (query, asyncJobId, callback) => {
  const res = await getHotelRates(query, asyncJobId);

  callback(res);

  if (res.asyncJobId) {
    getJobResult(query, res.asyncJobId, callback);
  }
};

export const getHotelRatesAsync = createSyncTag(async (form, callback) => {
  const res = await getHotelRates(form);
  callback(res);
  if (res.asyncJobId) {
    getJobResult(form, res.asyncJobId, callback);
  }
});

export const getHotelRule = async form => {
  const Y_TRAVELPORT_MESSAGE_DEBUGGING = useToggles(
    "Y_TRAVELPORT_MESSAGE_DEBUGGING"
  );
  if (Y_TRAVELPORT_MESSAGE_DEBUGGING.value) {
    if (!form._biz) {
      form._biz = {};
    }
    form._biz.tpMessageRequired = true;
  }
  const res = await http
    .post("booking/hotel/rateRule", {
      data: form
    })
    .catch(() => {});
  if (
    res &&
    res._biz &&
    res._biz.tpMessage &&
    Y_TRAVELPORT_MESSAGE_DEBUGGING.value
  ) {
    console.log("booking/hotel/rateRule>>>>tpMessage", res._biz.tpMessage);
  }
  return res;
};

// 酒店下单
export const createTpHotelOrder = async form => {
  const res = await http
    .post("booking/hotel/bookTp", {
      data: form
    })
    .catch(() => {});
  return res;
};

// 酒店订单列表
export const getHotelOrders = async form => {
  const res = await http
    .post("booking/order/search", {
      data: form
    })
    .catch(() => {});
  return res;
};

export const getOrderDetail = async (ref, type = "", options = {}) => {
  const { supplierBookingRequired = false } = options;
  const data = {
    preferred: {
      version: "v2",
      language: localStorage.getItem("y-locale")
        ? JSON.parse(localStorage.getItem("y-locale")) || "en"
        : "en"
    },
    paging: {
      skip: 0,
      limit: 1
    },
    filter: {
      _ids: [ref]
    }
  };
  if (type && type === "cruise") {
    data._biz = {
      supplierBookingRequired
    };
  }
  const orderRes = await http.post("booking/order/search", {
    data
  });
  return _.get(orderRes, "orders.0");
};

export const getHotelRateCalendar = async (date, hotelId) => {
  const query = {
    preferred: {
      version: "v1"
    },
    dateRange: {
      start: date.start.format("YYYY-MM-DD"),
      end: date.end.format("YYYY-MM-DD")
    },
    hotel: {
      _id: hotelId
    }
  };

  const url = "booking/hotel/rateCalendar";

  const res = await http.post(url, { data: query }).catch(() => {});

  return res;
};
